// ---------------- Helpers ---------------- //

export const formatEvents = (schedules: any[]) => {
  return schedules.flatMap((item) => {
    const startDate = item.startDate.replace(/z|Z/g, '');
    const endDate = item.endDate.replace(/z|Z/g, '');
    const start = new Date(startDate);
    const end = new Date(endDate);
    const title = item.title ?? '';

    const baseEvent = {
      ...item,
      startDate,
      endDate,
      start,
      end,
      id: item.idSchedule,
      title
    };

    const mode = item.studentScheduleMode || "ALL_TIME";
    let events: any[] = [];

    // ======================================================
    // ===============  MODO ALL_TIME  ======================

    if (mode === "ALL_TIME") {

      const isMultiDay = start.toDateString() !== end.toDateString();

      // Multi-dia → segmenta tudo (primeiro, meio, último)
      if (isMultiDay) {
        const startClean: any = new Date(start);
        startClean.setHours(0, 0, 0, 0);

        const endClean: any = new Date(end);
        endClean.setHours(0, 0, 0, 0);

        const totalDays =
          Math.round((endClean - startClean) / (1000 * 60 * 60 * 24)) + 1;

        for (let i = 0; i < totalDays; i++) {
          const dayStart = new Date(startClean);
          dayStart.setDate(startClean.getDate() + i);
          dayStart.setHours(0, 0, 0, 0);

          const dayEnd = new Date(dayStart);
          dayEnd.setHours(23, 59, 59, 999);

          events.push({
            ...baseEvent,
            start: dayStart,
            end: dayEnd,
            allDay: true,
            segmentPosition:
              i === 0 ? "first" : i === totalDays - 1 ? "last" : "middle"
          });
        }
      } else {
          // Apenas um dia
        if (!item.idEnrollment) {
          events.push({
            ...baseEvent,
            start,
            end,
            allDay: false,
            segmentPosition: "first"
          });
        } else {
          const dayStart = new Date(start);
          dayStart.setHours(0, 0, 0, 0);

          const dayEnd = new Date(end);
          dayEnd.setHours(23, 59, 59, 999);
          
          events.push({
            ...baseEvent,
            start: dayStart,
            end: dayEnd,
            allDay: true,
            segmentPosition: "first"
          });
        }
      }

      // Meetings
      if (item.meetings && item.meetings.length > 0) {
        const { meetings, startDate, finishDate, ...rest } = item;

        const meetingEvents = meetings.map((meeting: any, index: number) => {
          const meetingStart = new Date(meeting.startDate);
          const meetingEnd = new Date(meeting.finishDate);

          return {
            ...rest,
            ...meeting,
            start: meetingStart,
            end: meetingEnd,
            endDate: meeting.finishDate,
            id: meeting.idMeeting,
            type: "Meeting",
            title: `Encontro ${index + 1} - ${title}`
          };
        });

        events = events.concat(meetingEvents);
      }

      return events;
    }

    // ======================================================
    // ===============  MODO EXACT_DAYS =====================

    const isMultiDay = start.toDateString() !== end.toDateString();

    // --- 1) SCHEDULE START ---
    if (isMultiDay) {
      const firstDayStart = new Date(start);
      firstDayStart.setHours(0, 0, 0, 0);
      const firstDayEnd = new Date(start);
      firstDayEnd.setHours(23, 59, 59, 999);

      events.push({
        ...baseEvent,
        start: firstDayStart,
        end: firstDayEnd,
        allDay: true,
        type: "ScheduleStart"
      });
    }

    // --- 2) MEETINGS ---
    let meetingEvents: any[] = [];

    if (item.meetings && item.meetings.length > 0) {
      const { meetings, startDate, finishDate, ...rest } = item;

      meetingEvents = meetings.map((meeting: any, index: number) => {
        const meetingStart = new Date(meeting.startDate);
        const meetingEnd = new Date(meeting.finishDate);

        return {
          ...rest,
          ...meeting,
          start: meetingStart,
          end: meetingEnd,
          endDate: meeting.finishDate,
          id: meeting.idMeeting,
          type: "Meeting",
          title: `Encontro ${index + 1} - ${title}`
        };
      });
    }

    // --- 3) SCHEDULE END ---
    if (isMultiDay) {
      const lastDayStart = new Date(end);
      lastDayStart.setHours(0, 0, 0, 0);
      const lastDayEnd = new Date(end);
      lastDayEnd.setHours(23, 59, 59, 999);

      events.push({
        ...baseEvent,
        start: lastDayStart,
        end: lastDayEnd,
        allDay: true,
        type: "ScheduleEnd"
      });
    }

    // --- Evento de um dia ---
    if (!isMultiDay) {
      events = [baseEvent, ...meetingEvents];
      return events;
    }

    // Insere meetings ao final
    events = events.concat(meetingEvents);

    return events;
  });
};






export const sortEvents = (events) => {
    return [...events].sort((a, b) => {
        const startA:any = new Date(a.start);
        const startB:any = new Date(b.start);

        if (startA.toDateString() !== startB.toDateString()) {
            return startA - startB;
        }
        if (startA.getTime() !== startB.getTime()) {
            return startA.getTime() - startB.getTime();
        }
        return (a.title || '').localeCompare(b.title || '');
    });
}

export const TRAINING_OPTIONS = [
    {
        description: 'Assíncrono',
        idScheduleType: 'ASYNCHRONOUS',
    },
    {
        description: 'Blended',
        idScheduleType: 'BLENDED',
    },
];

export const formatDate = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false
});

export const formatDateOnly = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
});